/**
 * Compare two progress maps with a 0.001 tolerance threshold.
 * Returns true if they differ meaningfully.
 */
export function hasProgressChanged(
  nextMap: Record<string, number>,
  prevMap: Record<string, number>,
): boolean {
  const nextKeys = Object.keys(nextMap);
  const prevKeys = Object.keys(prevMap);
  if (nextKeys.length !== prevKeys.length) return true;
  for (const key of nextKeys) {
    if (Math.abs((nextMap[key] ?? 0) - (prevMap[key] ?? 0)) > 0.001) {
      return true;
    }
  }
  return false;
}
